<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            shortcut="last30Days"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
        <app-input
          @input.native="onOrdersSearch"
          v-model="filter_search"
          class="input--300"
          type="search"
          placeholder="Search by product name"
          name="search"
        />
        <app-select
          @input="onChangeFilter"
          v-model="filter_responsible"
          :options="responsible_center_options"
          placeholder="Responsible center"
          class="select--200"
        />
        <app-select
          @input="onChangeFilter"
          v-if="filter_responsible"
          v-model="filter_department"
          :options="department_options"
          placeholder="Department"
          class="select--200"
        />
        <app-select
          @search="onEmployeeSearch"
          @input="onChangeFilter"
          v-model="filter_employees"
          :options="employees_options"
          label="full_name"
          placeholder="Taken by"
          class="select--200"
        />
        <app-button theme="export" @click.native="onExport" :class="{'btn--export--loading': export_loading}">
          <img src="@/assets/img/export-icon.svg" alt="Export">
          <span>Export in .xlsx</span>
        </app-button>
      </app-cells>
      <app-cells><h2 class="title">
        Total value: {{ transfers_total ? transfers_total.toLocaleString() : 0 }} TSh | {{ transfers_total_usd ? transfers_total_usd.toLocaleString() : 0 }} USD
      </h2></app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name>
          <div class="table-default__left">Product name</div>
        </template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-products-detail', params: {id: row.id }}" class="table-default__link-border">
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #total_quantity="{ row }">
          {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.total_quantity) }}
        </template>
        <template #total_value="{ row }">
          {{ row.total_value.toLocaleString() }} TSh
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  getEmployeesListSearch,
  getProductStorageResponsibleCenter,
  getProductStorageTransferAnalyticsExport,
  getProductStorageTransfersAnalytics,
} from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { format, parse } from 'date-fns'

export default {
  name: 'ProductStorageAnalyticsTransfers',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      table_preloader: false,
      export_loading: false,
      transfers_total: null,
      transfers_total_usd: null,
      is_loaded: false,
      filter_search: '',
      filter_responsible: '',
      filter_department: '',
      filter_employees: '',
      filter_dates: null,
      custom_shortcuts: [
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      date_picker_error: false,
      employees_options: [],
      department_options: [],
      responsible_center_options: [],
      table: {
        items: [],
        columns: ['name', 'measurement.name', 'total_quantity', 'total_value'],
        options: {
          headings: {
            'name': 'Product name',
            'measurement.name': 'Unit',
            'total_quantity': 'Quantity',
            'total_value': 'Total value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 10000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    getProductStorageResponsibleCenter().then(response => {
      this.responsible_center_options = response.data
      this.is_loaded = true
      this.$nextTick(() => {
        this.fetchItems()
      })
    })
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getProductStorageTransfersAnalytics({
        search: this.filter_search,
        responsible_center: this.filter_responsible && this.filter_responsible.code,
        responsible_center_department: this.filter_department && this.filter_department.code,
        employee: this.filter_employees?.id,
        date_range_after: this.filter_dates.start,
        date_range_before: this.filter_dates.end,
      })
        .finally(() => { this.table_preloader = false })
        .then(response => {
          this.transfers_total = response.data.total_value
          this.transfers_total_usd = response.data.total_value_usd
          this.table.items = response.data.products
        })
    },
    onChangeFilter() {
      if (this.filter_responsible) {
        this.department_options = this.filter_responsible.departments
      } else {
        this.filter_department = ''
      }
      this.fetchItems()
    },
    onIsHiddenPicker() {
      if (this.filter_dates.hasOwnProperty('start') &&
        this.filter_dates.start &&
        this.filter_dates.hasOwnProperty('end') &&
        this.filter_dates.end) {
        this.date_picker_balance_error = false
        this.fetchItems()
      } else this.date_picker_balance_error = true
    },
    onOrdersSearch() {
      this.searchUsers(this)
    },
    searchUsers: debounce(vm => {
      vm.fetchItems()
    }, 350),
    onEmployeeSearch(search, loading) {
      loading(true)
      this.searchEmployee(loading, search, this)
    },
    searchEmployee: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.employees_options = []
      } else {
        getEmployeesListSearch({ search, employment_status: 'working' }).then(response => {
          loading(false)
          vm.employees_options = response.data
        })
      }
    }, 350),
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    onExport() {
      this.export_loading = true
      getProductStorageTransferAnalyticsExport(
        {
          responsible_center: this.filter_responsible && this.filter_responsible.code,
          responsible_center_department: this.filter_department && this.filter_department.code,
          employee: this.filter_employees,
          date_range_after: this.filter_dates.start,
          date_range_before: this.filter_dates.end,
        }
      )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Product storage transfers analytics from ${this.dateFormat(this.filter_dates.start)} to ${this.dateFormat(this.filter_dates.end)}${this.filter_responsible ? ` ${this.filter_responsible.name}` : ''}${this.filter_department ? ` (${this.filter_department.name})` : ''} ${format(new Date(), 'dd.MM.yyyy HH_mm')}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.export_loading = false
        })
    },
  }
}
</script>

<style lang="sass">
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
